import GenerateARModel from "./GenerateARModel.container";
export default GenerateARModel;
